import type { UserMessageData } from "app/pages/sales-intelligence/modules/ai-agent/store";
import type {
    FiltersStatePayload,
    InputFiltersStatePayload,
    LeadGeneratorAgentPayload,
} from "app/pages/sales-intelligence/modules/ai-agent/sub-modules/lead-generator/types/dto";

export function isInputFiltersStatePayload(
    payload: LeadGeneratorAgentPayload,
): payload is UserMessageData<Partial<InputFiltersStatePayload>> {
    return "inputFiltersState" in payload;
}

export function isApplicationStateWithFilters(
    payload: LeadGeneratorAgentPayload,
): payload is UserMessageData<{ readonly state: FiltersStatePayload }> {
    return (
        "state" in payload &&
        payload.state !== undefined &&
        "filtersState" in payload.state &&
        payload.state.filtersState !== undefined
    );
}
